import styled from "styled-components";

const LoggedOutSectionTitle = styled.div`
  font-weight: 900;
  font-size: 40px;
  /* text-align: center; */
  font-family: var(--headingFont);
  /*  */
  text-transform: uppercase;
  color: var(--element);

  @media (max-width: 900px) {
    font-size: 30px;
    text-align: center;
  }
`;

export default LoggedOutSectionTitle;
